import { useEffect } from 'react';
import { memo } from 'react';
import { useAppDispatch } from '../../../store/store';
import { setCurrentConversation, updateInbox } from '../../../store/slices/chat';
// import online from '../../../assets/icons/online.svg';
import moment from 'moment';
import 'moment/locale/de';
import 'moment/locale/fr';

import classes from './Inbox.module.scss';

import { getFullNameInitials } from '../../../helpers';
import { useTranslation } from '../../../hooks/useTranslations';

const InboxItem = memo(function InboxItem({ currentConversationId, item, notifications }: any) {
  const dispatch = useAppDispatch();
  const { translations } = useTranslation();
  const customer = item.participants.find((el: any) => el.assigned_as === 'C');
  const currentChatNotificaitons = notifications.filter(
    (el: any) => el?.conversation_id === item?.conversation_id
  );
  const customerFullName: string = `${customer?.person_name} ${customer?.person_lastname}`;
  const lang = localStorage.getItem('lang') || 'en';
  useEffect(() => {
    if (currentChatNotificaitons.length > 0) {
      // Update the inbox item with the last notification
      dispatch(updateInbox(currentChatNotificaitons[currentChatNotificaitons.length - 1]));
    }
    // eslint-disable-next-line
  }, [dispatch, notifications]);

  const handleSelect = () => {
    dispatch(setCurrentConversation(item));
  };

  const setClassName = () => {
    let res = `${classes.itemContent}`;
    // if (item.conversation_status === "C") {
    //   res = `${classes.itemContent} ${classes.closedConversation}`
    // }
    if (currentChatNotificaitons.length !== 0) {
      res = `${classes.itemContent} ${classes.bold}`;
    }
    return res;
  };

  return (
    <div
      className={
        currentConversationId === item.conversation_id
          ? `${classes.inboxItem} ${classes.selected}`
          : `${classes.inboxItem}`
      }
      onClick={handleSelect}
    >
      <div
        className={
          item.conversation_status === 'C'
            ? `${classes.wrapper} ${classes.closedConversation}`
            : `${classes.wrapper}`
        }
      >
        <div className={classes.icon}>
          {/* <img src={image} alt="callIcon" /> */}
          <div className={classes.avatar}>{getFullNameInitials(customerFullName)}</div>
          {/* {item.isOnline === 'online' && (
            <img src={online} className={classes.online} alt="callIcon" />
          )} */}
        </div>
        {/* <div className={item.status === 'closed' ? `${classes.itemContent} ${classes.closed}` : `${classes.itemContent}`}> */}
        <div className={setClassName()}>
          <p className={`${classes.smText}`}>{customerFullName}</p>
          <p className={`${classes.mainText}`}>
            {item.last_payload || translations('new.conversation')}
          </p>
        </div>
      </div>
      <div className={classes.wrapNotificaiton}>
        <div className={classes.time}>
          {item.last_payload_created_at
            ? moment(item.last_payload_created_at).locale(lang).fromNow()
            : ''}
        </div>
        {currentChatNotificaitons.length !== 0 ? (
          <div className={classes.notification}>{currentChatNotificaitons.length}</div>
        ) : null}
      </div>
    </div>
  );
});

export default InboxItem;
